<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <CookiesPolicy />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CookiesPolicy from '@/components/legal/CookiesPolicy'

export default {
  components: {
    CookiesPolicy,
  },
}
</script>
